import { render, staticRenderFns } from "./EmbroideryItems.vue?vue&type=template&id=1ac51122&scoped=true&"
import script from "./EmbroideryItems.vue?vue&type=script&lang=js&"
export * from "./EmbroideryItems.vue?vue&type=script&lang=js&"
import style0 from "./EmbroideryItems.vue?vue&type=style&index=0&id=1ac51122&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac51122",
  null
  
)

export default component.exports